import React from 'react'
import RegisterManConForm, { defaultValues } from './form'

export const validate = ({ personnel, PRODARANumber }) => personnel && PRODARANumber

export const available = available_actions => (available_actions || []).includes('register_mancon')

const apiEndPoint = provider_registration_id =>
  process.env.REACT_APP_API_HOST +
  `/api/provider-registrations/${provider_registration_id}/register-mancon`

// eslint-disable-next-line react/display-name
const form = provider_registration_id => props => (
  <RegisterManConForm {...props} provider_registration_id={provider_registration_id} />
)

const registerManCon = ({ record: { provider_registration_id, available_actions }, onComplete }) =>
  available(available_actions)
    ? {
      label: 'Register New',
      value: 'register_mancon',
      component: form(provider_registration_id),
      url: apiEndPoint(provider_registration_id),
      canDisplayErrors: true,
      onComplete,
      formOptions: {
        validate,
        defaultValues,
      },
    }
    : null

export default registerManCon



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/index.js